import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateExportSettingsMutationVariables = Types.Exact<{
  input: Types.ExportSettingsInput;
}>;


export type UpdateExportSettingsMutation = { __typename?: 'Mutation', updateExportSettings?: { __typename?: 'ExportSettings', localCopyEnabled?: boolean | null, localFolderPath?: string | null, assetFolderId?: string | null, assetFolderName?: string | null, presetId?: string | null, range?: Types.ExportAssetRange | null, exportMarkersAsCommentsEnabled?: boolean | null } | null };


export const UpdateExportSettings = /*#__PURE__*/ gql`
    mutation UpdateExportSettings($input: ExportSettingsInput!) {
  updateExportSettings(input: $input) {
    localCopyEnabled
    localFolderPath
    assetFolderId
    assetFolderName
    presetId
    range
    exportMarkersAsCommentsEnabled
  }
}
    ` as unknown as DocumentNode<UpdateExportSettingsMutation, UpdateExportSettingsMutationVariables>;

          

          export const useUpdateExportSettingsMutation = (options?:MutationHookOptions<UpdateExportSettingsMutation, UpdateExportSettingsMutationVariables>) => useMutation(UpdateExportSettings, options);
          

          export type UpdateExportSettingsMutationOptions = MutationHookOptions<UpdateExportSettingsMutation, UpdateExportSettingsMutationVariables>;

          

          export type UpdateExportSettingsMutationResult = ReturnType<typeof useUpdateExportSettingsMutation>[1];

          
